import { Link } from 'react-router';
import { CountBadge, EmptyState, Icon, PageHeader, type NavItem } from '@saas/ui';
import { useNavModel } from '../shell/nav.js';

/**
 * 🗂 業務ホーム（WORK-01 の Web 版）: 有効なモジュールの入口を 2 列のタイルで。
 * タイルは高さ 96 以上、アイコン 28 + headline。
 */
function Tile({ item, count }: { item: NavItem; count?: number }) {
  return (
    <li>
      <Link
        to={item.to}
        target={item.newWindow ? '_blank' : undefined}
        rel={item.newWindow ? 'noopener noreferrer' : undefined}
        className="flex min-h-24 flex-col justify-between rounded-card border border-[var(--card-border-color)] bg-card p-5 shadow-elev-1 transition-colors hover:bg-sunken"
      >
        <span className="flex items-center justify-between">
          <span className="inline-flex rounded-input bg-accent-fill p-3 text-accent"><Icon name={item.icon} size={24} /></span>
          {count ? <CountBadge count={count} label={item.label} /> : null}
        </span>
        <span className="mt-3 flex items-center gap-2 text-headline wrap-name">
          {item.label}
          {item.newWindow ? <Icon name="open_in_new" size={20} className="text-fg-tertiary" /> : null}
        </span>
        {item.description ? <span className="text-caption text-fg-secondary">{item.description}</span> : null}
      </Link>
    </li>
  );
}

export function WorkHomePage() {
  const model = useNavModel();
  const tiles = model.work.flatMap((g) => g.items);
  return (
    <>
      <PageHeader title="業務" description="使う機能を選んでください" />
      {tiles.length === 0 ? (
        <EmptyState icon="home_repair_service" title="利用できる業務はありません" description="管理者がモジュールを有効にすると、ここに並びます" />
      ) : (
        <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
          {tiles.map((it) => (
            <Tile key={it.to} item={it} count={it.badge ? model.counts[it.badge] : undefined} />
          ))}
        </ul>
      )}
    </>
  );
}
